import styled from '@emotion/styled'

/**
 * The stage container for an in-person room.
 *
 * A sibling of `video-layout-resolver.tsx`, not a branch inside it: that file
 * maps a focused feature onto a *video* arrangement, and an in-person session
 * has no streams to arrange. All this has to do is hand the focused feature
 * whatever height and width the shell left over.
 *
 * `position: relative` so a feature can position against the stage rather
 * than the viewport; `min-height: 0` so a tall feature scrolls inside the
 * stage instead of pushing the room header and menu off screen.
 *
 * The padding is the stage's, not each feature's. A slide sizes itself to its
 * own aspect ratio and is therefore a content-sized flex item, so without
 * `justify-content` it sits hard against the left edge of a projector instead
 * of in the middle of it. The 10px at the bottom keeps whatever is on the
 * stage clear of the auto-hiding menu's resting handle.
 */
export const InPersonLayout = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	min-height: 0;
	min-width: 0;
	width: 100%;
	justify-content: center;
	padding: 0 24px 10px;
`
